import React from "react";
import { useTranslation } from "react-i18next";
import { Heading, StyledAbout } from "./About.style";

import ContentBlock from "../../components/ContentBlock";
import Divider from "../../components/Divider";

/**
 * Archive Page - Show a list of previous reports.
 */
const About = ({ ...rest }) => {
  const { t } = useTranslation();

  return (
    <StyledAbout>
      <Heading>{t("about.heading")}</Heading>

      <ContentBlock heading={t("about.how.heading")}>
        {t("about.how.content")}
      </ContentBlock>
      <Divider />

      <ContentBlock heading={t("about.councilTax.heading")}>
        {t("about.councilTax.content")}
      </ContentBlock>
      <Divider />

      <ContentBlock heading={t("about.lifeSatisfaction.heading")}>
        {t("about.lifeSatisfaction.content")}
      </ContentBlock>
      <Divider />
      <ContentBlock heading={t("about.averageSalary.heading")}>
        {t("about.averageSalary.content")}
      </ContentBlock>
    </StyledAbout>
  );
};

export default About;
